import type { NodeSerializerSpec } from "@ext/markdown/core/edit/logic/Prosemirror/to_markdown";
import type { Node } from "prosemirror-model";

/** The alignment of a column lives in the delimiter row of a Markdown table. */
const alignMarker = (cell: Node) => {
	if (cell.attrs.align === "left") return ":---";
	if (cell.attrs.align === "center") return ":---:";
	if (cell.attrs.align === "right") return "---:";
	return "---";
};

const tableHeaderRowSimple: NodeSerializerSpec = async (state, node) => {
	await state.renderContent(node);

	const delimiters: string[] = [];
	node.forEach((cell) => delimiters.push(alignMarker(cell)));
	state.write(`|\n${state.delim}|${delimiters.join("|")}|\n`);
};

export default tableHeaderRowSimple;
